// notificationService.js
// API service functions for Notification System

import API from './api';

// ============================================================================
// Notification Rules
// ============================================================================

export const getNotificationRules = async () => {
  const response = await API.get('/notification-rules/');
  return response.data;
};

export const createNotificationRule = async (data) => {
  const response = await API.post('/notification-rule/create/', data);
  return response.data;
};

export const updateNotificationRule = async (data) => {
  const response = await API.put('/notification-rule/update/', data);
  return response.data;
};

export const deleteNotificationRule = async (ruleId) => {
  const response = await API.delete('/notification-rule/delete/', {
    data: { NotificationRuleID: ruleId }
  });
  return response.data;
};

export const previewNotificationRule = async (data) => {
  const response = await API.post('/notification-rule/preview/', data);
  return response.data;
};

// ============================================================================
// Notifications
// ============================================================================

export const getNotifications = async ({ page = 1, pageSize = 20, isRead } = {}) => {
  const params = { page, page_size: pageSize };
  if (isRead !== undefined) params.is_read = isRead;
  const response = await API.get('/notifications/', { params });
  return response.data;
};

export const getUnreadCount = async () => {
  const response = await API.get('/notifications/unread-count/');
  return response.data;
};

export const markAsRead = async (notificationId) => {
  const response = await API.put('/notification/read/', {
    NotificationID: notificationId
  });
  return response.data;
};

export const markAsUnread = async (notificationId) => {
  const response = await API.put('/notification/unread/', {
    NotificationID: notificationId
  });
  return response.data;
};

export const markAllAsRead = async () => {
  const response = await API.put('/notifications/read-all/');
  return response.data;
};

export const deleteNotification = async (notificationId) => {
  const response = await API.delete('/notification/delete/', {
    data: { NotificationID: notificationId }
  });
  return response.data;
};
